import React from 'react';
import Render from './render';

class PageNotFound extends React.PureComponent {
  render() {
    return Render.call(this, this.props, this.state);
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.tsx